// extracted by mini-css-extract-plugin
export var container = "_hz-0";
export var dotAnimation = "_hz-2";
export var dotsLoading = "_hz-1";